import {
  AddressModel,
  ClientModel,
  DebtModel,
  EnterpriseModel,
  EquipmentModel,
  ReceiptModel,
  TemplateFormat,
  TYPE_SEARCH,
  UserModel
} from 'shared';
import { UUID } from 'symbols';

export interface TalonModel {
  id: string;
  docNumber: number;
  createdAt: string;
  version: number;
  equipment: Partial<EquipmentModel>;
  warrantyPeriod: number;
  equipmentId?: string;
  street: AddressModel['street'],
  country: AddressModel['country'],
  city: AddressModel['city'],
  client?: Partial<ClientModel>;
  clientId?: string;
  debt?: DebtModel;
  debtId?: string;
  receipts?: ReceiptModel[];
  receiptsIds?: string[];
  warranty?: Partial<WarrantyModel>;
  updater?: UserModel;
  isChanged?: boolean;
  isNew?: boolean;
  enterpriseId?: string;
  enterprise?: EnterpriseModel;
  isCanceled: boolean;
  comment?: string;
  mediatorId?: string;
  mediator?: UserModel;
  isUsed: boolean;
}


export interface TalonsFilterModel {
  isDebt?: boolean;
  searchText?: string;
  typeSearch?: TYPE_SEARCH;
}


export interface WarrantyModel {
  id: UUID;
  equipmentId?: UUID;

  warrantyEndDate: string;
  warrantyPeriod: number;
  warrantyStartDate: string;
  warrantyStatus: WarrantyStatus;
}

export enum WarrantyStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  LAUNCH_OVERDUE = 'launch_overdue',
  NO_LAUNCHED = 'no_launched',
}


export const TALON_WARRANTY_STATUS_RELATIONS_NAME: { [status: string]: string } = {
  [WarrantyStatus.ACTIVE]: 'Гарантія дійсна до',
  [WarrantyStatus.EXPIRED]: 'Гарантія закінчилась',
  [WarrantyStatus.LAUNCH_OVERDUE]: 'Запуск прострочено',
  [WarrantyStatus.NO_LAUNCHED]: 'Період запуску'
};


export interface TalonModelExpectBackend {
  id: string;
  version: number;
  docNumber: number;
  createdAt: string;
  equipment: EquipmentModel;
  street: string;
  country: string;
  city: string;
  client: ClientModel;
  receiptsIds: string[];
  receipts: ReceiptModel[];
  debtId: string;
  debt: DebtModel;
  enterprise: EnterpriseModel;
  isCanceled: boolean;
  isNew?: boolean;
}


export const TALONS_LOCAL_STORAGE_KEY = 'talons_data';
